<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Staff Update <b>[{{ moment(this.date).format('ddd DD, MMM YYYY') }}]</b></h5>
        </div>
        <div class="col-6 col-sm-4 text-right">

        </div>
      </div>
    </div>
    <div>
      <single-update-element :date="date" :attendancedata="attendancedata"></single-update-element>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import singleUpdateElement from '@/components/StaffAttendance/Forms/singleupdate'

export default {
  components: { singleUpdateElement },
  data: function() {
    return {
      date: null,
      attendancedata: [],
    }
  },
  created: function() {
    this.date = this.$route.params.day
    this.$http.get(`/api/staff/attendance/report/daily?start_date=${this.date}&end_date=${this.date}`).then((data) => {
      // console.log(data.data)
      this.attendancedata = data.data.data.attendance.map(function(e) {
        return { date: e.date, staffname: `${e.first_name} ${e.last_name}`, holiday: e.is_holiday, staffid: e.system_staff_id, staffcode: e.staffId, status: e.status }
      })
      console.log('this.attendancedata', this.attendancedata)
    })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    moment,
  },
}
</script>

<style>

</style>
